import * as React from 'react'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface IProps {
  eyebrow?: string
  title: React.ReactNode
  description?: React.ReactNode
  footer?: React.ReactNode
  maxWidthClassName?: string
  children?: React.ReactNode
}

const OauthCard = ({ eyebrow, title, description, footer, maxWidthClassName = 'max-w-lg', children }: IProps) => {
  return (
    <Card className={cn('w-full md:min-w-[500px]', maxWidthClassName)}>
      <CardHeader>
        {eyebrow && <Badge variant="outline" className="mb-2 w-fit text-primary uppercase tracking-wide">
          {eyebrow}
        </Badge>}
        <CardTitle className="text-2xl leading-tight font-bold text-balance md:text-3xl">
          {title}
        </CardTitle>
        {description && <CardDescription className="text-base">{description}</CardDescription>}
      </CardHeader>
      {children && <CardContent className="space-y-6">{children}</CardContent>}
      {footer && <CardFooter className="flex-col items-stretch gap-3">{footer}</CardFooter>}
    </Card>
  )
}

export default OauthCard
